import { isBoolean, camelCase } from 'lodash-es'
import { useEffect, useCallback } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useValidateLDFlags } from '../useValidateLDFlags/useValidateLDFlags'
import { flags as expectedFlags } from '../../FeatureFlagsProvider.consts'

export const useGlobalLDFlagsGetter = () => {
  const flags = useFlags()

  const getLDFlags = useCallback<GetLDFlags>(
    (...searchedFlags) => {
      if (!searchedFlags.length) {
        return { ...flags }
      }

      return Object.fromEntries(
        Object.entries(flags || {}).filter(([key, value]) =>
          searchedFlags.some((search) =>
            isBoolean(search) ? value === search : search === key || camelCase(search.toString()) === key,
          ),
        ),
      )
    },
    [flags],
  )

  useEffect(() => {
    Object.assign(window, { getLDFlags })
  }, [getLDFlags])
}

export const GlobalLDFlagsGetter = () => {
  useGlobalLDFlagsGetter()
  useValidateLDFlags(expectedFlags)

  return null
}
